import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { OwnerPermissionsResponseDto } from '@/features/owners/types/owners-dto';
import { Roles } from '@/@types/auth.types';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';

type Props = {
    role?: Roles;
};

export const usePermissionsListApi = ({ role }: Props = {}) => {
    const axiosInstance = useAxiosAuth();

    const {
        data: permissionsListData, 
        isLoading: isLoadingPermissionsListData, 
        isError: isErrorPermissionsListData
    } = useQuery({
        queryKey: [ApiConfig.queries.features.owners.permissions.myList.queryKey],
        queryFn: async (): Promise<OwnerPermissionsResponseDto> => {
            const url = ApiConfig.queries.features.owners.permissions.myList.endpoint;
            const response = await axiosInstance.get<OwnerPermissionsResponseDto>(url);
            return response.data;
        },
        placeholderData: keepPreviousData,
        enabled: role && role === Roles.owner
    });

    return {
        permissionsListData,
        isLoadingPermissionsListData,
        isErrorPermissionsListData,   
    }
}